import { useCallback, useEffect, useState } from "react";
import { useMediosAudio } from "../context/MediosAudioContext";

export function useMediosChannelAudio(channel) {
  const { otherHasAudio, claim, release } = useMediosAudio(channel);
  const [muted, setMuted] = useState(true);
  const [volume, setVolume] = useState(80);

  useEffect(() => {
    if (otherHasAudio) setMuted(true);
  }, [otherHasAudio]);

  const setMutedExclusive = useCallback(
    (nextMuted) => {
      if (nextMuted) {
        setMuted(true);
        release();
        return;
      }
      claim();
      setMuted(false);
      setVolume((v) => (v < 5 ? 80 : v));
    },
    [claim, release]
  );

  const bumpVolume = useCallback(
    (delta) => {
      setVolume((v) => {
        const base = muted ? 0 : v;
        const next = Math.min(100, Math.max(0, base + delta));
        if (next <= 0) {
          setMuted(true);
          release();
          return 0;
        }
        claim();
        setMuted(false);
        return next;
      });
    },
    [muted, claim, release]
  );

  const setVolumeLevel = useCallback(
    (raw) => {
      const next = Math.min(100, Math.max(0, Number(raw) || 0));
      if (next <= 0) {
        setMuted(true);
        release();
        setVolume(0);
        return;
      }
      claim();
      setMuted(false);
      setVolume(next);
    },
    [claim, release]
  );

  return { muted, volume, setMutedExclusive, bumpVolume, setVolumeLevel };
}
